import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql, withPrefix } from 'gatsby';
import { map } from 'lodash/fp';

// localization
import LocaleContext from '../../LocaleContext';
import locales from '../../i18n/config';

// components
import SiteHeader from '../SiteHeader/SiteHeader';
import Footer from '../Footer/Footer';
import Background from '../Background/Background';

// helpers
import { delocalizePath, localizePath } from '../../helpers/localeHelpers';

// styles
import './index.scss';

class TemplateWrapper extends Component {
  defaultState = { color: 'white', loadScripts: false };

  static contextType = LocaleContext;

  constructor(props) {
    super(props);
    this.state = this.defaultState;
  }

 /*  UNSAFE_componentWillMount() {} */

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Any time location changes, update state.
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.setState(this.defaultState);
    }
  }

  componentDidMount() {
      this.setState( {...this.state, loadScripts: true});
  }

  handleLogoColor = color => {
    this.setState({ ...this.state, color });
  };

  generateAlternateLinks = (languageSelectorInformation, pathname, locale) => {
      const baseUrl = 'https://www.cloudnine.se';
      const delocalizedPath = delocalizePath(pathname, locale);
      if(languageSelectorInformation && languageSelectorInformation.localesList) {
        return languageSelectorInformation.localesList.map(item => {
            const localizedPath = localizePath(delocalizedPath, item);
            return {url: `${baseUrl}${localizedPath}`, hrefLang: locales[item].hrefLang};
        })
      }
      return map((item) => {
          const localizedPath = localizePath(delocalizedPath, item.name);
          return {url: `${baseUrl}${localizedPath}`, hrefLang: item.hrefLang};
      }, locales)
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query TemplateQuery {
            contentTypes: allContentfulContentType {
              edges {
                node {
                  id
                }
              }
            }
            slogan: contentfulMicrocopyPages {
              titleStartPage
              ogImageStartPage {
                file {
                  url
                }
              }
            }
          }
        `}
        render={data => {
          const {
            title,
            description,
            keywords,
            ogType,
            ogImage,
            logoBlack,
            logoColor,
            location,
            languageSelectorInformation,
            halfPage,
            children
          } = this.props;
          const { locale } = this.context; // Not deprecated even if webstorm says so..
          const pageUrl = `https://www.cloudnine.se${location.pathname}`;

          const alternateLinks = this.generateAlternateLinks(languageSelectorInformation, location.pathname, locale);

          return (
            <div>
              <Helmet>
                <title>{`${title ? title : 'cloudnine.se'} | Cloud Nine`}</title>
                <meta name="description" content={description} />
                <meta name="keywords" content={keywords} />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:type" content={ogType} />
                <meta property="og:url" content={pageUrl} />
                <meta property="og:image" content={ogImage ? ogImage : data.slogan.ogImageStartPage.file.url} />
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0, viewport-fit=cover" />
                <meta name="msapplication-TileColor" content="#ffffff" />
                <meta name="theme-color" content="#ffffff" />

                <link rel="apple-touch-icon" sizes="180x180" href={withPrefix(`/favicons/apple-touch-icon.png`)} />
                <link rel="icon" type="image/png" sizes="32x32" href={withPrefix(`/favicons/favicon-32x32.png`)} />
                <link rel="icon" type="image/png" sizes="16x16" href={withPrefix(`/favicons/favicon-16x16.png`)} />
                <link rel="manifest" href={withPrefix(`/favicons/site.webmanifest`)} />
                <link rel="mask-icon" color="#000000" href={withPrefix(`/favicons/safari-pinned-tab.svg`)} />

                { locales[locale] && <html lang={locales[locale].locale} /> }
                { alternateLinks.map((item, i) => <link key={i} rel="alternate" href={item.url} hrefLang={item.hrefLang}/>) }


                <script>
                  {typeof window !== 'undefined' &&
                    typeof document !== 'undefined' &&
                    (function(w, d) {
                      let id = 'embedly-platform',
                        n = 'script';
                      if (!d.getElementById(id)) {
                        w.embedly =
                          w.embedly ||
                          function() {
                            (w.embedly.q = w.embedly.q || []).push(arguments);
                          };
                        var e = d.createElement(n);
                        e.id = id;
                        e.async = 1;
                        e.src =
                          ('https:' === document.location.protocol
                            ? 'https'
                            : 'http') +
                          '://cdn.embedly.com/widgets/platform.js';
                        var s = d.getElementsByTagName(n)[0];
                        s.parentNode.insertBefore(e, s);
                      }
                    })(window, document)}
                </script>
                  { this.state.loadScripts &&
                    <script
                      data-culture={locales[locale].name}
                      id="Cookiebot"
                      src="https://consent.cookiebot.com/uc.js"
                      data-cbid="e9472a28-043c-48ca-a794-9882e6c9ad2b"
                      type="text/javascript"
                      async
                    />
                  }
              </Helmet>
              <Background />
              <SiteHeader
                color={logoBlack ? 'black' : this.state.color}
                logoColor={logoColor}
                pathname={location.pathname}
                halfPage={halfPage}
                languageSelectorInformation={languageSelectorInformation}
              />
              {children}
              <Footer />

              <Helmet />
            </div>
          );
        }}
      />
    );
  }
}

export default TemplateWrapper;

TemplateWrapper.defaultProps = {
  children: [],
  location: {},
  halfPage: false,
  logoColor: null,
  title: '',
  description:
    'Cloud Nine är en ledande digital byrå för dig som tror på den affärsdrivande kraften i digitala lösningar',
  keywords: 'Cloud Nine, digital byrå, webbutveckling, e-handel',
  ogType: 'website',
  ogImage: '',
};

TemplateWrapper.propTypes = {
  children: PropTypes.node,
  location: PropTypes.object,
  logoColor: PropTypes.any,
  halfPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  ogType: PropTypes.string,
  ogImage: PropTypes.string,
};
